import { cursorPaginationFieldPolicy } from '../../../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  MountedStorageRecentUser: {
    keyFields: false,
  },
  Project: {
    fields: {
      directMemberships: cursorPaginationFieldPolicy(['filter', ['query']]),
      indirectMemberships: cursorPaginationFieldPolicy([
        'filter',
        ['query', 'grantingResource'],
      ]),
      mountedStorageRecentUsers: cursorPaginationFieldPolicy(['days']),
    },
  },
};
